module.exports = __webpack_public_path__ + "img/Puente_Istobal_M1_Alto_Blanco-default-front.42b37f5f.jpg";